import {useLocation, useNavigate} from "react-router-dom";
import React, {useCallback} from "react";
import {SquadflixCollectionResp} from "../../app/myProfileView/my-profile-subroutes/my-profile-lists/types";
import auth from "../../../utils/authentication";
import {SquadDiskUsersApi} from "../../../apis/squaddisk-users/SquadDiskUsersApi";

type SquadflixNavigationEntry = {
    pathName: string;
    key: string;
    customKey?: React.ReactNode;
}

export class SquadflixNavigationRecord {
    static readonly history: SquadflixNavigationEntry[] = [];

    static addEntry(entry: SquadflixNavigationEntry) {
        this.history.unshift(entry);
    }

    static getLastEntry() {
        return this.history.length > 0 ? this.history[0] : {
            pathName: '/squadflix',
            key: 'squadflix'
        };
    }
}

const UseSquadflixNavigate = ({navKey}: { navKey?: React.ReactNode }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const navigateToEpisode = useCallback((episode, customNavKey?: React.ReactNode) => {
        SquadflixNavigationRecord.addEntry({
            pathName: location.pathname,
            key: location.pathname.replace(/\//g, ''),
            customKey: customNavKey || navKey
        });
        navigate(`/squadflix/series/${episode.show_id}/${episode.season_number}/${episode.episode_number}`);
    }, [location.pathname, navKey, navigate]);

    const navigateToSerie = useCallback((serie, customNavKey?: React.ReactNode) => {
        SquadflixNavigationRecord.addEntry({
            pathName: location.pathname,
            key: location.pathname.replace(/\//g, ''),
            customKey: customNavKey || navKey
        });
        navigate(`/squadflix/series/${serie.id}`);
    }, [location.pathname, navKey, navigate]);

    const navigateToMovie = useCallback((movie, customNavKey?: React.ReactNode) => {
        SquadflixNavigationRecord.addEntry({
            pathName: location.pathname,
            key: location.pathname.replace(/\//g, ''),
            customKey: customNavKey || navKey
        });
        navigate(`/squadflix/movies/${movie.id}`);
    }, [location.pathname, navKey, navigate]);

    const navigateToCollectionDetails = useCallback((collection: SquadflixCollectionResp["collection"]) => {
        if (auth.currentUser.uid === collection.uid) {
            navigate(`/my-profile/collections/${collection.id}`)
        } else {
            SquadDiskUsersApi.getUserInfoByUid({uid: collection.uid}).then((userResp) => {
                navigate(`/user/${userResp.user.displayName}/${userResp.user.code}/squadflix/collections/${collection.id}`);
            }).catch(() => {
            });
        }
    }, [navigate]);

    const navigateToLive = useCallback((linkGroup, customNavKey?: React.ReactNode) => {
        navigate(`/squadflix/live?cat=${encodeURIComponent(linkGroup.name)}`);
    }, [navigate]);

    return {
        navigateToEpisode,
        navigateToSerie,
        navigateToMovie,
        navigateToLive,
        navigateToCollectionDetails
    }
}

export default UseSquadflixNavigate;
